module.exports = __webpack_public_path__ + "img/sr.986893cf.png";